/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_LockedInputs */

const cs_workflow_locked = /** @type {(inputs: Workflow_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknuto vámi`)
};

const en_workflow_locked = /** @type {(inputs: Workflow_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked by you`)
};

/**
* | output |
* | --- |
* | "Locked by you" |
*
* @param {Workflow_LockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_locked = /** @type {((inputs?: Workflow_LockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_LockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_locked(inputs)
	return cs_workflow_locked(inputs)
});